var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CrLayout',{attrs:{"isAuthorized":_vm.isAuthorized}},[_c('v-main',[_c('CrTable',{attrs:{"isAuthorized":_vm.isAuthorized}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }